import React from 'react';
import { motion } from 'framer-motion';
import { Check, Flame, ThermometerSun, Snowflake, Wind, Wrench } from 'lucide-react';
import { ServicePageHero } from '../components/ServicePageHero';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function ChillerHire() {
  const features = ['REFCOM F-GAS certified', 'Process & comfort cooling', 'Full turnkey solution', 'Nationwide delivery', '24/7 support', 'Brand new equipment'];
  const relatedServices = [{
    title: 'Boiler Hire',
    icon: Flame,
    path: '/boiler-hire'
  }, {
    title: 'Heater Hire',
    icon: ThermometerSun,
    path: '/heater-hire'
  }, {
    title: 'Cooling Hire',
    icon: Wind,
    path: '/cooling-hire'
  }, {
    title: 'Ancillaries',
    icon: Wrench,
    path: '/ancillaries'
  }];
  return <main className="flex-grow" data-id="element-302">
      <ServicePageHero title="Chiller Hire" subtitle="High performance process and comfort cooling chillers available for immediate dispatch." bgImage="https://rapidenergy.co.uk/wp-content/uploads/2026/03/Rapid-Energy-van-next-to-packaged-boiler.webp" data-id="element-303" />

      <section className="py-20 bg-white" data-id="element-304">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-305">
          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-306">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2" data-id="element-307">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark mb-6" data-id="element-308">
                Reliable Industrial Chillers
              </h2>

              <div className="space-y-4 text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-309">
                <p data-id="element-310">
                  REFCOM F-GAS certified, experienced and skilled engineers,
                  brand new equipment and a{' '}
                  <strong data-id="element-311">5 star, verified customer service</strong>. You can
                  trust the team at Rapid Energy to deliver a consistent,
                  reliable chiller hire service.
                </p>
                <p data-id="element-312">
                  Our modern, efficient industrial chillers have been designed
                  specifically for the hire industry and are perfect for both
                  process and comfort cooling applications. If you're unsure of
                  which chiller is suitable for your application, a member of
                  our team can support and consult you on identifying the
                  appropriate chiller and cooling solution.
                </p>
                <p data-id="element-313">
                  We offer our clients a complete{' '}
                  <strong data-id="element-314">full turnkey hire solution</strong>, from surveying
                  through to commissioning a temporary chiller. Our team will
                  effectively be an extension of your team throughout the
                  duration of the project.
                </p>
                <p data-id="element-315">
                  Typical industry sectors and applications include: Contingency
                  and Emergency Requirements, Chemical & Pharmaceutical, HVAC
                  and Building Services, Process Cooling, Low Temperature
                  Requirements, Food & Beverage Sectors and many more.
                </p>
                <p data-id="element-316">
                  We support and deliver nationwide in England, Scotland and
                  Wales. We also operate a <strong data-id="element-317">24/7 service</strong> to
                  support our clients throughout the duration of a hire.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-318">
                {features.map((feature, i) => <div key={i} className="flex items-start" data-id="element-319">
                    <div className="bg-brand-green/20 p-1 rounded-full mr-3 mt-1 flex-shrink-0" data-id="element-320">
                      <Check className="w-4 h-4 text-brand-dark" data-id="element-321" />
                    </div>
                    <span className="text-sm font-medium text-brand-dark" data-id="element-322">
                      {feature}
                    </span>
                  </div>)}
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/2 sticky top-24" data-id="element-323">
              <img src="https://rapidenergy.co.uk/wp-content/uploads/2025/04/360kW-Heat-Pump-Chiller-555px-by-555px.webp" alt="360kW Heat Pump Chiller" className="rounded-2xl shadow-2xl w-full object-cover h-[500px]" data-id="element-324" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-16 bg-brand-light" data-id="element-325">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-326">
          <h3 className="text-2xl font-heading font-bold text-brand-dark mb-8 text-center" data-id="element-327">
            Related Services
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-328">
            {relatedServices.map((service, index) => <Link key={index} to={service.path} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group flex flex-col items-center text-center" data-id="element-329">
                <div className="w-12 h-12 bg-brand-light rounded-lg flex items-center justify-center mb-4 group-hover:bg-brand-green/20 transition-colors" data-id="element-330">
                  <service.icon className="w-6 h-6 text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-331" />
                </div>
                <h4 className="font-heading font-bold text-brand-dark group-hover:text-brand-green transition-colors" data-id="element-332">
                  {service.title}
                </h4>
              </Link>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-333" />
    </main>;
}